import { render, staticRenderFns } from "./CommentsRating.vue?vue&type=template&id=2291ba5f&scoped=true&"
import script from "./CommentsRating.vue?vue&type=script&lang=js&"
export * from "./CommentsRating.vue?vue&type=script&lang=js&"
import style0 from "./CommentsRating.vue?vue&type=style&index=0&id=2291ba5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2291ba5f",
  null
  
)

export default component.exports